import moment from 'moment';
import { HEALTH_STATUS } from '@/constants/businessProcess/constants';
import store from '@/store';

export default class BusinessProcessKpi {
  constructor(data) {
    Object.assign(this, structuredClone(data));
  }

  get amount() {
    let result;

    if (this.isDuration) {
      result = moment(this.value, 'H:m:s.S') || moment(this.value, 'H:m:s');
    } else if (this.isPercentage) {
      result = Math.round(this.value * 100, 2);
    } else {
      result = Math.round(this.value, 2);
    }

    return result;
  }

  get warningThreshold() {
    return this.isDuration
      ? moment(this.thresholds.warning, 'H:m:s.S') || moment(this.thresholds.warning, 'H:m:s')
      : this.thresholds.warning;
  }

  get dangerThreshold() {
    return this.isDuration
      ? moment(this.thresholds.danger, 'H:m:s.S') || moment(this.thresholds.danger, 'H:m:s')
      : this.thresholds.danger;
  }

  get status() {
    let fallbackResult;
    if (this.thresholds.danger && this.thresholds.warning) {
      const status = this.healthStatus;
      if (this.percentage && this.percentage.status) {
        return status < this.percentage.status ? status : this.percentage.status;
      } else {
        return status;
      }
    } else if (this.percentage && this.percentage.status) {
      return this.percentage.status;
    } else {
      return fallbackResult;
    }
  }

  get healthStatus() {
    if (['businessProcessServiceLevel'].includes(this.id)) {
      const fallbackStatus = this.amount < this.dangerThreshold ? HEALTH_STATUS.Danger : HEALTH_STATUS.Warning;
      return this.amount >= this.warningThreshold ? HEALTH_STATUS.Good : fallbackStatus;
    } else {
      const fallbackStatus = this.amount < this.warningThreshold ? HEALTH_STATUS.Good : HEALTH_STATUS.Warning;
      return this.amount >= this.dangerThreshold ? HEALTH_STATUS.Danger : fallbackStatus;
    }
  }

  get isDuration() {
    return (
      this.counterType === 'TimeSpan' ||
      [
        'businessProcessLongestWaitingTime',
        'businessProcessAverageWaitingTime',
        'businessProcessAverageAgentHandlingTime',
        'businessProcessAverageAnswerTime',
        'callbackAverageHandlingTime'
      ].includes(this.id)
    );
  }

  get isPercentage() {
    return (
      this.counterType === 'Percentage' ||
      [
        'businessProcessServiceLevel',
        'businessProcessAnsweredPercentage',
        'businessProcessAbandonedPercentage',
        'callbackSuccessfulPercentageInShift',
        'callbackFailedPercentageInShift'
      ].includes(this.id)
    );
  }

  get type() {
    const numericType = this.isPercentage ? 'Percentage' : 'Count';
    return this.counterType || (this.isDuration ? 'TimeSpan' : numericType);
  }

  get units() {
    return this.isPercentage ? '%' : '';
  }

  get isLive() {
    const activeBPHealthThreshold = store.getters['BUSINESS_PROCESSES/getActiveBusinessProcessHealthThreshold'](
      this.businessProcessId
    );
    const kpis = activeBPHealthThreshold ? activeBPHealthThreshold.businessProcessKpis : {};
    const waitingInteractions = kpis.businessProcessWaitingInteractions;
    return this.isDuration && ['businessProcessLongestWaitingTime'].includes(this.id) && waitingInteractions.value > 0;
  }
}
